import React, { useContext } from 'react'
import { useLocation } from 'react-router-dom'
import LandingPageWrapper from '../../elem/landing-page/LandingPageWrapper'
import { UserContext } from '../../wrappers/UserContext'
import withConfig from '../../wrappers/withConfig'

const LoginPage = withConfig(({ config }) => {
    const { client } = useContext(UserContext)
    const { search } = useLocation()
    const { CONFIGURED_URLS } = config

    // set the redirect uri in local storage so callback component can redirect to it
    // after the user logs in 
    const redirectTargetUri = new URLSearchParams(search).get('redirect')
    if (redirectTargetUri) {
        localStorage.setItem('redirectTargetUri', encodeURI(redirectTargetUri))
    }

    return (
        <LandingPageWrapper>
            <div style={{ zIndex: 3 }} className="myDashboardsText is-size-4 authenticationText">
                <p>
                    Please {' '}
                    <span
                        className="authenticationLink"
                        onClick={function () {
                            client.signinRedirect()
                        }}
                    >
                        Login
                    </span>
                    {' '} or {' '}
                    <a
                        className="authenticationLink"
                        target="_blank"
                        rel="opener"
                        href={CONFIGURED_URLS.newRegistration}
                    >
                        Register
                    </a>
                    {' '}to access dashboards
                </p>
            </div>
        </LandingPageWrapper>
    )
})

export default LoginPage
